var setActiveLink = function (_a) {
    var isActive = _a.isActive;
    return isActive ? 'link_active' : 'link';
};
export default setActiveLink;
